import Aes from "crypto-js/aes";
import CryptoJS from "crypto-js";

const transformDate = (date: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
    const hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
    const min = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
    const second = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
    return `${year}/${month}/${day} ${hour}:${min}:${second}`
}

const transformDate2 = (date: any, type: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()

    if (type === 1) {
        return `${year}/${month}/${day} 00:00:00`
    } else if (type === 2) {
        return `${year}/${month}/${day} 23:59:59`
    }
}

const transformDate3 = (date: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
    return `${year}/${month}/${day}`
}

const getRealFactoryIdList = () => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories || []
    const factory_id = localStorage.getItem('factory_id')

    // console.log('factories', factories)
    // console.log('factory_id', factory_id)
    let factoryIds: any = []
    const list = factories.filter((p: any) => p.parentId === factory_id)

    if (list && list.length) {
        factoryIds = list.map((p: any) => p.id)
    } else {
        factoryIds = [factory_id]
    }
    return factoryIds
}

const getRealFactoryIdListById = (factory_id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories || []

    let factoryIds: any = []
    const list = factories.filter((p: any) => p.parentId === factory_id)

    if (list && list.length) {
        factoryIds = list.map((p: any) => p.id)
    } else {
        factoryIds = [factory_id]
    }
    return factoryIds
}

const getFactoryName = (id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories
    const info = factories.find((p: any) => p.id === id)
    return info ? info.name : ''
}

const getGroupName = (id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const groups = memberInfo.groups
    const info = groups.find((p: any) => p.id === id)
    return info ? info.name : ''
}

const getGroupListByFactory = () => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const groups = memberInfo.groups || []
    const factory_id = localStorage.getItem('factory_id')
    const groupList = groups.filter((p: any) => p.factoryId === factory_id || p.parentId === factory_id)
    return groupList
}

const getGroupListByFacID = (factoryId: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '[]')
    const groups = memberInfo.groups || []
    const factory_id = factoryId
    const groupList = groups.filter((p: any) => p.factoryId === factory_id || p.parentId === factory_id)
    return groupList
}

const transformBeiJingDate = (date:any) => {
    if(!date) return ''
    let time = new Date(date);

    // 本地时间的时间戳（毫秒）
    const localTimestamp = time.getTime();
    // 本地与北京的时区差（分钟）：北京是UTC+8（-480分钟），差值 = 本地偏移 - 北京偏移
    // const offsetDiff = 0 - (localTimezoneOffset() - (-480)); 
    const offsetDiff =  (-480) - time.getTimezoneOffset()
    console.log('offsetDiff', offsetDiff)
    // 北京时间戳 = 本地时间戳 - 时差（转换为毫秒）
    const beijingTimestamp = localTimestamp - offsetDiff * 60 * 1000;
    // 格式化北京时间
    return new Date(beijingTimestamp).toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
}

const transformLocalDate = (date:any) => {
    if(!date) return ''
    let time = new Date(date);
    let currentDate = new Date()
    const beijingTimestamp = time.getTime();
    const utcTimestamp = beijingTimestamp - 8 * 60 * 60 * 1000;

    // 3. 计算本地时间：UTC时间 + 本地时区偏移（因为本地偏移是UTC-本地，所以需要加回来）
    const localOffsetMinutes = currentDate.getTimezoneOffset(); // 本地与UTC的偏移（分钟，东为负）
    const localTimestamp = utcTimestamp - localOffsetMinutes * 60 * 1000;

    // 4. 格式化本地时间
    return new Date(localTimestamp).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
}

export {
    transformDate,
    transformDate2,
    transformDate3,
    getRealFactoryIdList,
    getFactoryName,
    getGroupName,
    getGroupListByFactory,
    getRealFactoryIdListById,
    getGroupListByFacID,
    transformBeiJingDate,
    transformLocalDate,
}

const _k = (function () { return '$Y6hE3' + '%ZCGTn0' + 'b9Sl20mm' + "VANksF4WQuq" })();
export const encryptAes = (text: string): string => {
    let key = CryptoJS.enc.Utf8.parse(_k);
    return Aes.encrypt(text, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString();
}

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

let conditionList = [
    { label: '健康', value: 0, level: 0 },
    { label: '可用', value: 1, level: 1 },
    { label: '可用', value: 2, level: 1 },
    { label: '警戒', value: 3, level: 2 },
    { label: '警戒', value: 4, level: 2 },
    { label: '警戒', value: 5, level: 2 },
    { label: '故障', value: 6, level: 3 },
    { label: '故障', value: 7, level: 3 }
]

export function convertConditionToLevel(condition: number | null): number {
    if (!condition) return 0;
    let item = conditionList.find(p => p.value === condition);
    if (item) return item.level;
    return 0;
}
